/**
 * Base64 Utility Functions
 * Provides encoding and decoding utilities for base64 and base64url
 */

/**
 * Convert base64url to standard base64
 */
export function base64UrlToBase64(base64url: string): string {
  // Replace base64url characters with base64 characters
  let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');

  // Add padding if needed
  const padding = base64.length % 4;
  if (padding > 0) {
    base64 += '='.repeat(4 - padding);
  }

  return base64;
}

/**
 * Decode a base64url-encoded JSON string
 */
export function decodeBase64UrlJson<T = any>(base64url: string): T {
  try {
    const base64 = base64UrlToBase64(base64url);
    const jsonString = atob(base64);
    return JSON.parse(jsonString);
  } catch (error) {
    throw new Error(`Failed to decode base64url JSON: ${error}`);
  }
}

/**
 * Encode a JSON object to base64url
 */
export function encodeJsonToBase64Url(obj: any): string {
  try {
    const jsonString = JSON.stringify(obj);
    const base64 = btoa(jsonString);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  } catch (error) {
    throw new Error(`Failed to encode JSON to base64url: ${error}`);
  }
}

/**
 * Alias for encodeJsonToBase64Url
 */
export const encodeBase64Url = encodeJsonToBase64Url;

/**
 * Safe decode base64url with error handling
 */
export function safeDecodeBase64<T = any>(base64url: string): T | null {
  try {
    return decodeBase64UrlJson<T>(base64url);
  } catch (error) {
    console.error('Failed to decode base64url:', error);
    return null;
  }
}
